import { AfterViewInit, Component, HostListener, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MegaMenu } from '@app/@shared/models/navigation/navigation.models';
import { NavigationService } from '@app/@shared/services/navigation/navigation.service';
import { environment } from '@env/environment';
import { combineLatest, Observable } from 'rxjs';
import { URLUtils } from '@app/@shared/utils/url-utils';

@Component({
    selector: 'app-nav-mega-menu',
    templateUrl: './nav-mega-menu.component.html',
    styleUrls: ['./nav-mega-menu.component.scss'],
    standalone: false
})
export class NavMegaMenuComponent implements OnInit {
  @Input() getMegaMenu: () => Observable<MegaMenu[]>;

  @ViewChildren('megaMenuHeader') megaMenuHeaders: QueryList<HTMLElement>;

  menuItems: MegaMenu[] = [];
  currentlyOpenMenu: string;
  selectedMenu: string;
  disableMenu = false;
  basePath = environment.basePath;
  dropdownWidth = 0;

  private readonly minDropdownWidth = 1080;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
  ) {
    this.getMegaMenu = this.getMegaMenu ?? this.navigationService.getMegaMenu.bind(this.navigationService);
  }

  ngOnInit(): void {
    this.dropdownWidth = this.minDropdownWidth;
    combineLatest([this.getMegaMenu(), this.route.queryParamMap]).subscribe(
      ([megaMenu, queryParams]) => {
        const activeMenu = queryParams.get('activeMenu');
        this.menuItems = megaMenu;
        this.setMenuActive('');

        // Calculate after render
        setTimeout  (() => {
          this.calculateDropdownWidth();
        });

        if (activeMenu) {
          this.setMenuActive(activeMenu);
        }
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.calculateDropdownWidth();
  }

  buildQueryParams(link: string, name: string): string {
    const linkPrefix = environment.basePath;
    if(link?.includes('tech-library')) {
      return link;
    }
    const url = URLUtils.addQueryParams(linkPrefix + link, { activeMenu: name });
    return url.replace(linkPrefix, '');
  }

  onClickMenuItem(link: string, name: string, disableMenu: boolean = false) {
    if(link) {
      const url = this.buildQueryParams(link, name);
      this.router.navigateByUrl(url);
    }
    this.currentlyOpenMenu = name;
    this.selectedMenu = name;
    this.disableMenu = disableMenu
  }

  closeMenu() {
    this.currentlyOpenMenu = '';
    this.selectedMenu = '';
  }

  openMenu(menuName: string): void {
    this.currentlyOpenMenu = menuName;
    if(this.selectedMenu !== menuName){
      this.selectedMenu = '';
      this.disableMenu = false;
    }
  }

  hasMenu(item: MegaMenu) {
    return item.primaryMenu?.length > 0 || item.secondaryMenu?.length > 0;
  }

  private setMenuActive(activeMenu: string){
    this.menuItems = this.menuItems.map((item) => ({
      ...item,
      active: item.name === activeMenu,
    }));
  }

  private calculateDropdownWidth() {
    let accumulator = 0;
    this.megaMenuHeaders.forEach((e: any) => {
      accumulator += e.nativeElement.clientWidth;
    });
    // Pick whichever is larger the elements sum or the minimum width,
    // then check if it exceeds the window width if it does, just use the window width.
    this.dropdownWidth = Math.min(Math.max(this.minDropdownWidth, accumulator), window.innerWidth);
  }
}
